import { useState } from 'react'
import { Field, Form, useFormik, FormikProvider } from 'formik'
import TextInput from 'common/FormInputs/TextInput'
import { emailSchema } from 'utils/commonYupSchemas'
import styles from './index.module.scss'
import logEvent from 'utils/logEvent'
import { RudderEvent } from 'constants/rudderEvents'
import useCreateSalesforceLead from 'hooks/salesforce/useSalesforceCreateLead'
import { useRouter } from 'next/router'

const NewsletterSignup: React.FC<unknown> = () => {
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false)
  const router = useRouter()
  const handleNewLead = useCreateSalesforceLead()

  const onSubmit = (data) => {
    setSubmitting(true)

    handleNewLead({
      LastName: data.email, // we're following the same pattern as in the WP footer form
      Email: data.email,
      Form_URL__c: router.asPath,
      LeadSource: 'Newsletter',
    }).finally(() => {
      logEvent(RudderEvent.NEWSLETTER_EMAIL_SUBMITTED)
      setHasSubmitted(true)
    })
    resetForm()
  }

  const NewsletterFormikContext = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: emailSchema,
    onSubmit,
  })
  const { resetForm, setSubmitting, isValid } = NewsletterFormikContext
  return (
    <div className={styles.newsletter_inline}>
      {hasSubmitted ? (
        <div className={styles.header_newsletter_signup_horizontal}>
          Congrats! You&apos;ve signed up successfully — stay tuned for our next
          newsletter.
        </div>
      ) : (
        <>
          <div className={styles.header_newsletter_signup_inline}>
            <span className={styles.desktop_text}>
              Get the latest mental
              <br />
              wellness tips &amp; discussions,
              <br />
              straight to your inbox
            </span>
            <span className={styles.mobile_text}>
              Get the latest mental wellness
              <br />
              tips &amp; discussions, straight to your inbox
            </span>
          </div>
          <div className={styles.newsletter_form_inline}>
            <FormikProvider value={NewsletterFormikContext}>
              <Form>
                <div
                  className={styles.newsletter_input_wrapper}
                  data-testid="newsletterSignupButton"
                >
                  <Field
                    id="email_address_input"
                    type="email"
                    name="email"
                    placeholder="Enter your email to sign up"
                    containerClassName={styles.input_container_horizontal}
                    inputContainerClassName={
                      styles.input_inner_container_hidden
                    }
                    inputClass={styles.input_newsletter_horizontal}
                    component={TextInput}
                    showNewsletterErrorComponent={true}
                    aria-label="Email Address"
                  />
                  <button
                    aria-label="Sign up button"
                    type="submit"
                    className={styles.button_newsletter_arrow}
                    disabled={!isValid}
                  >
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5 12H19M19 12L12 5M19 12L12 19"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </Form>
            </FormikProvider>
            <div className={styles.newsletter_subtext_horizontal}>
              Free, and no spam ever. Unsubscribe anytime.
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default NewsletterSignup
